// functions/pagination.ts

export interface PaginationItem {
  text: string;
  page: number;
  active: boolean;
  placeHolder: boolean;
  visible: boolean;
}

export const createPagination = (current: number, totalPages: number): PaginationItem[] => {
  current = current < 1 ? 1 : current > totalPages ? totalPages : current;

  const getPrevArrow = (): PaginationItem => {
    if (current <= 1) {
      return { text: '<', page: 1, active: false, placeHolder: true, visible: false };
    } else {
      return { text: '<', page: current - 1, active: false, placeHolder: true, visible: true };
    }
  };

  const getNextArrow = (): PaginationItem => {
    if (current >= totalPages) {
      return { text: '>', page: totalPages, active: false, placeHolder: true, visible: false };
    } else {
      return { text: '>', page: current + 1, active: false, placeHolder: true, visible: true };
    }
  };

  const getAllPages = (): PaginationItem[] => {
    return Array.from({ length: totalPages }, (_, i) => {
      const page = i + 1;
      return { text: page.toString(), page, active: page === current, placeHolder: false, visible: true };
    });
  };

  const getLowAmountOfPages = (): PaginationItem[] => {
    return [
      ...Array.from({ length: 4 }, (_, i) => {
        const page = i + 1;
        return { text: page.toString(), page, active: page === current, placeHolder: false, visible: true };
      }),
      { text: '...', page: 5, active: false, placeHolder: true, visible: true },
      { text: totalPages.toString(), page: totalPages, active: false, placeHolder: false, visible: true }
    ];
  };

  const getCloseToEndPages = (): PaginationItem[] => {
    return [
      { text: '1', page: 1, active: false, placeHolder: false, visible: true },
      { text: '...', page: totalPages - 4, active: false, placeHolder: true, visible: true },
      ...Array.from({ length: 4 }, (_, i) => {
        const page = totalPages - 3 + i;
        return { text: page.toString(), page, active: page === current, placeHolder: false, visible: true };
      })
    ];
  };

  const getNormalPages = (): PaginationItem[] => {
    return [
      { text: '1', page: 1, active: false, placeHolder: false, visible: true },
      { text: '...', page: current - 1, active: false, placeHolder: true, visible: true },
      { text: (current - 1).toString(), page: current - 1, active: false, placeHolder: false, visible: true },
      { text: current.toString(), page: current, active: true, placeHolder: false, visible: true },
      { text: (current + 1).toString(), page: current + 1, active: false, placeHolder: false, visible: true },
      { text: '...', page: current + 2, active: false, placeHolder: true, visible: true },
      { text: totalPages.toString(), page: totalPages, active: false, placeHolder: false, visible: true }
    ];
  };

  const pages: PaginationItem[] = [getPrevArrow()];

  if (totalPages <= 5) {
    pages.push(...getAllPages());
  } else {
    if (current < 4) {
      pages.push(...getLowAmountOfPages());
    } else if (current > totalPages - 3) {
      pages.push(...getCloseToEndPages());
    } else {
      pages.push(...getNormalPages());
    }
  }

  pages.push(getNextArrow());
  return pages;
};
